import { z } from 'zod';

import RealisationByHoursQuantity from './AvailableWidgets/RealisationByHoursQuantity/RealisationByHoursQuantity.svelte';
import RealisationByHoursPercent from './AvailableWidgets/RealisationByHoursPercent/RealisationByHoursPercent.svelte';
import RealisationByHoursGwarants from './AvailableWidgets/RealisationByHoursGwarants/RealisationByHoursGwarants.svelte';
import RealisationDelivery from './AvailableWidgets/RealisationDelivery/RealisationDelivery.svelte';
import RealisationGwarants from './AvailableWidgets/RealisationGwarants/RealisationGwarants.svelte';
import {
    StatusApiDataRequestSchema,
    StatusApiDefaultSettings,
} from '../../shared/Dashboard/WidgetOneApi';
import JobStatus from './AvailableWidgets/JobStatus/JobStatus.svelte';
import RouteCostWeek from './AvailableWidgets/RouteCostWeek/RouteCostWeek.svelte';
import RouteDistanceWeek from './AvailableWidgets/RouteDistanceWeek/RouteDistanceWeek.svelte';
import { features } from '../../shared/Features/features';
import { get, writable } from 'svelte/store';
import GanttCouriers from './AvailableWidgets/GanttCouriers/GanttCouriers.svelte';

export const WidgetSettingsOptionsSchema = z.object({
    reloadInterval: z.boolean(),
    filter: z.boolean(),
    collectionName: z.string().default('jobs').describe('Name of the collection to use in filter'),
    fullWidth: z.boolean().optional().default(false).describe('If true, widget will be full width'),
    useSelectedDay: z.boolean().default(false),
    doubleHeight: z
        .boolean()
        .optional()
        .default(false)
        .describe('If true, widget will be double height'),
});
export type WidgetSettingsOptionsType = z.infer<typeof WidgetSettingsOptionsSchema>;

export const AvailableWidgetSchema = z.object({
    id: z.number(),
    title: z.string(),
    enabled: z.boolean(),
    widgetName: z.string(),
    component: z.any(),
    // componentSettings: z.any(),
    settingsSchema: z.any(),
    defaultSettings: StatusApiDataRequestSchema,
    settingsOptions: WidgetSettingsOptionsSchema,
});
export type AvailableWidgetType = z.infer<typeof AvailableWidgetSchema>;

export const availableWidgets = writable<AvailableWidgetType[]>([
    // {
    //     id: 10,
    //     title: 'Status zleceń [%] (old)',
    //     enabled: false,
    //     widgetName: 'JobStatus',
    //     component: Status,
    //     // componentSettings: StatusSettings,
    //     settingsSchema: StatusApiDataRequestSchema,
    //     settingsOptions: {
    //         reloadInterval: true,
    //         filter: true,
    //     },
    //     defaultSettings: StatusApiDataRequestSchema.parse(StatusApiDefaultSettings),
    // },
    {
        id: 10,
        title: 'jobs_status_percent',
        enabled: true,
        widgetName: 'JobStatus',
        component: JobStatus,
        // componentSettings: StatusSettings,
        settingsSchema: StatusApiDataRequestSchema,
        settingsOptions: {
            reloadInterval: true,
            filter: true,
            collectionName: 'jobs',
            fullWidth: false,
            doubleHeight: false,
            useSelectedDay: false,
        },
        defaultSettings: StatusApiDataRequestSchema.parse(StatusApiDefaultSettings),
    },
    {
        id: 20,
        title: 'jobs_completion', //  [tys.]',
        enabled: true,
        widgetName: 'RealisationByHoursQuantity',
        component: RealisationByHoursQuantity,
        // componentSettings: RealisationByHoursQuantitySettings,
        settingsSchema: StatusApiDataRequestSchema,
        settingsOptions: {
            reloadInterval: true,
            filter: true,
            collectionName: 'jobs',
            fullWidth: false,
            doubleHeight: false,
            useSelectedDay: false,
        },
        defaultSettings: StatusApiDataRequestSchema.parse(StatusApiDefaultSettings),
    },
    {
        id: 30,
        title: 'Zlecenia do wykonania [%]',
        enabled: true,
        widgetName: 'RealisationByHoursPercent',
        component: RealisationByHoursPercent,
        // componentSettings: RealisationByHoursPercentSettings,
        settingsSchema: StatusApiDataRequestSchema,
        settingsOptions: {
            reloadInterval: true,
            filter: true,
            collectionName: 'jobs',
            fullWidth: false,
            doubleHeight: false,
            useSelectedDay: false,
        },
        defaultSettings: StatusApiDataRequestSchema.parse(StatusApiDefaultSettings),
    },
    {
        id: 40,
        title: 'guarantors_completion', //  [tys.]',
        enabled: true,
        widgetName: 'RealisationByHoursGwarants',
        component: RealisationByHoursGwarants,
        // componentSettings: RealisationByHoursGwarantsSettings,
        settingsSchema: StatusApiDataRequestSchema,
        settingsOptions: {
            reloadInterval: true,
            filter: true,
            collectionName: 'jobs',
            fullWidth: false,
            doubleHeight: false,
            useSelectedDay: false,
        },
        defaultSettings: StatusApiDataRequestSchema.parse(StatusApiDefaultSettings),
    },
    {
        id: 50,
        title: 'Status realizacji', //  [tys.]
        enabled: true,
        widgetName: 'RealisationDelivery',
        component: RealisationDelivery,
        // componentSettings: RealisationDeliverySettings,
        settingsSchema: StatusApiDataRequestSchema,
        settingsOptions: {
            reloadInterval: true,
            filter: true,
            collectionName: 'jobs',
            fullWidth: false,
            doubleHeight: false,
            useSelectedDay: false,
        },
        defaultSettings: StatusApiDataRequestSchema.parse(StatusApiDefaultSettings),
    },
    {
        id: 60,
        title: 'guarantors_status', // [tys.]
        enabled: true,
        widgetName: 'RealisationGwarants',
        component: RealisationGwarants,
        // componentSettings: RealisationGwarantsSettings,
        settingsSchema: StatusApiDataRequestSchema,
        settingsOptions: {
            reloadInterval: true,
            filter: true,
            collectionName: 'jobs',
            fullWidth: false,
            doubleHeight: false,
            useSelectedDay: false,
        },
        defaultSettings: StatusApiDataRequestSchema.parse(StatusApiDefaultSettings),
    },
    {
        id: 70,
        title: 'costs_per_weekday',
        enabled: get(features).feature_enable_route_distance_and_cost_dashboards,
        widgetName: 'RouteCostWeek',
        component: RouteCostWeek,
        settingsSchema: StatusApiDataRequestSchema,
        settingsOptions: {
            reloadInterval: true,
            filter: false,
            collectionName: 'jobs',
            fullWidth: false,
            doubleHeight: false,
            useSelectedDay: false,
        },
        defaultSettings: StatusApiDataRequestSchema.parse(StatusApiDefaultSettings),
    },
    {
        id: 80,
        title: 'km_per_weekday',
        enabled: get(features).feature_enable_route_distance_and_cost_dashboards,
        widgetName: 'RouteDistanceWeek',
        component: RouteDistanceWeek,
        settingsSchema: StatusApiDataRequestSchema,
        settingsOptions: {
            reloadInterval: true,
            filter: false,
            collectionName: 'jobs',
            fullWidth: false,
            doubleHeight: false,
            useSelectedDay: false,
        },
        defaultSettings: StatusApiDataRequestSchema.parse(StatusApiDefaultSettings),
    },
    {
        id: 100,
        title: 'gantt_chart_routes',
        enabled: get(features).feature_enable_gantt_couriers_dashboards,
        widgetName: 'GanttCouriers',
        component: GanttCouriers,
        settingsSchema: StatusApiDataRequestSchema,
        settingsOptions: {
            reloadInterval: true,
            filter: true,
            collectionName: 'assignments',
            fullWidth: true,
            doubleHeight: true,
            useSelectedDay: true,
        },
        defaultSettings: StatusApiDataRequestSchema.parse(StatusApiDefaultSettings),
    },
]);

// on update features, update availableWidgets
features.subscribe(value => {
    availableWidgets.update(widgets => {
        widgets.forEach(widget => {
            if (widget.id === 70 || widget.id === 80) {
                widget.enabled = value.feature_enable_route_distance_and_cost_dashboards;
            }
        });
        return widgets;
    });
});
